import { createFileRoute } from '@tanstack/react-router'
import { QueryGuard } from '../../../components/query-guard'
import { InvestorProfile } from '../../../features/investor/components/investor-profile'
import { useInvestorByIdQuery } from '../../../hooks/api'

export const Route = createFileRoute('/_protected/investors/$id')({
  component: InvestorByIdPage,
})

function InvestorByIdPage() {
  const { id } = Route.useParams()
  const investorQuery = useInvestorByIdQuery(id)

  return (
    <QueryGuard query={investorQuery} errorMessage="Failed to load investor">
      {(investor, permissions) => <InvestorProfile investor={investor} permissions={permissions} />}
    </QueryGuard>
  )
}
